import React from 'react';
import Reveal from './Reveal';
import { STATS } from '../mock';
import PatternBg from './PatternBg';

export default function Stats() {
  return (
    <section id="method" className="relative overflow-hidden bg-[var(--ob-bg)] py-24 md:py-32">
      <PatternBg
        size={175}
        opacity={0.08}
        mask="radial-gradient(85% 85% at 50% 42%, #000 18%, transparent 68%)"
      />
      <div className="relative mx-auto max-w-[1280px] px-5 md:px-8">
        <Reveal className="mx-auto mb-16 max-w-2xl text-center">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--ob-accent-dark)]">
            The OnBrand Method
          </p>
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-[var(--ob-ink)] md:text-6xl">
            We engineer revenue.
          </h2>
          <p className="mt-5 text-lg text-[var(--ob-ink-soft)]">
            We deconstruct and rebuild email systems for 8- to 9-figure Shopify brands.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 120}>
              <div className="flex h-full flex-col items-center justify-center rounded-3xl border border-[var(--ob-line)] bg-white px-8 py-14 text-center">
                <div className="font-display text-6xl font-extrabold tracking-tight text-[var(--ob-ink)] md:text-7xl">
                  {s.value}
                </div>
                <div className="mt-4 text-lg font-semibold text-[var(--ob-ink)]">{s.label}</div>
                <div className="mt-1 text-sm text-[var(--ob-ink-soft)]">{s.sub}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
